<template>
  <v-container>
    <v-row v-if="error">
      <v-col cols="12" sm="6" offset-sm-3>
        <app-alert @dismissed="onDismissed" class="red" :text="error.message"></app-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onSignin">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                    name="email"
                    label="Email"
                    id="signInEmail"
                    v-model="email"
                    type="email"
                    required></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                    name="password"
                    label="Password"
                    id="signInPass"
                    v-model="password"
                    type="password"
                    required></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-btn class="primary" type="submit" :disabled="loading" :loading="loading">
                      Sign in
                    </v-btn>
                    <p class="d-inline-block float-right mt-2" @click="emailDialog = true"><a>Forgot Password</a></p>
                  </v-col>
                </v-row>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <template>
      <v-dialog
      v-model="emailDialog"
      max-width="390"
      >
      <v-card>
        <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        >
        <v-card-title dark class="headline">Reset Password</v-card-title>
        <v-card-text>
          <v-text-field
          class="mt-5"
          name="passwordReset"
          v-model="email"
          label="Email: "
          :rules="[rules.required, rules.email]"
          required="true"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" type="submit" @click.prevent="resetPassword()" :disabled="!valid" :loading="loading2">Reset</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
</v-container>
</template>

<script>
import firebase from '@/helpers/firebaseConfig'
export default {
  data () {
    return {
      valid: false,
      email: '',
      password: '',
      emailDialog: false,
      loading2: false,
      rules: {
          required: (value) => !!value || 'Required.',
          email: (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        }
    }
  },
  props: {

  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
          // this.$router.push('/options')
        }
      }
    },
    methods: {
      onSignin () {
        this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
      },
      onDismissed () {
        this.$store.dispatch('clearError')
      },
      resetPassword(){
        let auth = firebase.auth()
        this.loading2 = true
        auth.sendPasswordResetEmail(this.email).then(function() {
          // Email sent.
          this.loading2 = false
          this.emailDialog = false
          this.$store.commit('setSnack', "Check Your Email For Instructions On Resetting Your Password")

        }).catch(function(error) {
          // An error happened.
        })
      }
    }
  }
  </script>
